// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._36Idh .modal__header{text-align:center}._36Idh .modal__content{padding:0 1.6rem 1.6rem}", ""]);
// Exports
exports.locals = {
	"modal__wrapper": "_36Idh"
};
module.exports = exports;
